import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const blackbirdSearchAppBuilder = DataRouterApplicationBuilder.create('blackbird-search')
